import React, { useEffect, useRef } from 'react';
import { endpoints } from 'Core/defaultValues';

const ZonarELDView = () => {

    const iframeRef = useRef(null);

    // Get the token
    const idToken = localStorage.getItem("IdToken");
    const refreshToken = localStorage.getItem("RefreshToken");
    const username = localStorage.getItem("username");

    const params = new URLSearchParams({
        pxLogin: 'true',
    });
    let a = params.toString();
    const url = `${endpoints.ZONAR_ELD_APP_URL}/driver-logs/?${a}`;

    useEffect(() => {
        const sendToken = () => {
            if (iframeRef.current && iframeRef.current.contentWindow) {
                iframeRef.current.contentWindow.postMessage(
                    { idToken, refreshToken, username }, url
                );
                //sending a post message simultaneously to second application within the same iframe
                iframeRef.current.contentWindow.postMessage(
                    { idToken, refreshToken, username }, `${endpoints.ZONAR_CI_APP_URL}/?${a}`
                );
            }
        };

        // Send the token once the iframe loads
        const iframe = iframeRef.current;
        if (iframe) {
            iframe.onload = sendToken;
        }
    }, [idToken]); // Re-run if the token changes

    return (
        <div style={{ height: '95vh' }}>
            {
                <iframe
                    ref={iframeRef}
                    id="zonar-eld-portal"
                    title="ZONAR Eld Portal"
                    width="100%"
                    height="100%"
                    src={ url }
                >
                </iframe>
            }
        </div>
    )
}

export default ZonarELDView
